import { useMemo, type FC } from "react"

import type { DevicePlotDef } from "types/dashboard.types"

import { useBendingAmplitudeViews } from "helpers/hooks/plots/useBendingAmplitudeViews"
import useDevices from "helpers/hooks/useDevices"
import DeviceTelemetryPlot from "./DeviceTelemetryPlot"

interface DevicePlotProps {
  def: DevicePlotDef
  deviceIds: number[]
}

const DevicePlot: FC<DevicePlotProps> = ({ def, deviceIds }) => {
  const { devsWRelsById } = useDevices()
  const device = devsWRelsById?.[deviceIds[0]]?.device

  const { view } = useBendingAmplitudeViews(def, device)
  const defWithView = useMemo((): DevicePlotDef => ({ ...def, view }), [def, view])

  return <DeviceTelemetryPlot def={defWithView} deviceIds={deviceIds} />
}

export default DevicePlot
